import { Datepicker } from 'vanillajs-datepicker';

Datepicker.locales.de = {
    days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Damstag'],
    daysShort: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
    daysMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    months: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
    ],
    monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    today: 'Heute',
    clear: 'Löschen',
    titleFormat: 'MM y',
    format: 'yyyy-mm-dd',
    weekstart: 0,
};

(() => {
    const initStateReady = () => {
        const inputs = document.querySelectorAll('input[type="date"]');
        inputs.forEach((input) => {
            if (input.type !== 'date') {
                const datePicker = new Datepicker(input, {
                    language: 'de',
                });
            }
        });
    };

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') return;

        initStateReady();
    });
})();
